function updateCartProperties(event) {
    console.log('updateCartProperties called');
    event.preventDefault();

    const itemsToProcess = document.querySelectorAll('.mx-items-total-count');
    console.log('Found items to process:', itemsToProcess.length);

    if (itemsToProcess.length === 0) {
        window.location.href = '/checkout';
        return;
    }

    async function processItems() {
      try {
          const cartResponse = await fetch('/cart.js');
          const cart = await cartResponse.json();

          for (const item of itemsToProcess) {
              const itemsTotalText = item.dataset.itemsTotalText;
              const itemKey = item.dataset.itemKey;

              const cartItem = cart.items.find(i => i.key === itemKey);
              const currentQuantity = cartItem ? cartItem.quantity : 1;
              const currentProperties = cartItem ? cartItem.properties : {};

              const properties = {
                ...currentProperties,
                'Total': itemsTotalText
              }

              const response = await fetch('/cart/change.js', {
                  method: 'POST',
                  headers: {
                      'Content-Type': 'application/json',
                      'Accept': 'application/json'
                  },
                  body: JSON.stringify({
                      id: itemKey,
                      quantity: currentQuantity,
                      properties: properties
                  })
              });

              if (!response.ok) {
                  throw new Error(`Failed to update item ${itemKey}: ${response.status}`);
              }

              console.log(`Successfully updated item ${itemKey}`);
          }

          console.log('All items processed successfully');

          window.location.href = '/checkout';
      } catch (error) {
          console.error('Error processing items:', error);
          window.location.href = '/checkout';
      }
  }

  processItems();
}

document.addEventListener("DOMContentLoaded", (event) => {
  const checkoutButton = document.querySelector('button[id="checkout"][type="submit"]');
  if (checkoutButton) {
      checkoutButton.addEventListener('click', function(event) {
          console.log('Checkout button clicked');
          updateCartProperties(event);
      }, true);
  } else {
      console.error('Checkout button not found');
  }
});
